import React from 'react'
import { Col } from "react-bootstrap";
import { error } from './style'

export function renderField(field)
{
	return (
		<div className='form-group'>
			<label className={field.labelattrs}>{field.label}</label>
			<Col className={field.inputattrs}>
				<input
					className="form-control"
                    defaultvalue={field.defaultvalue}
					placeholder={field.placeholder ? field.placeholder: ''}
					type={field.type ? field.type: 'text'}
					{...field.input}
					disabled={field.disabled}
			/>
				{field.meta.touched && field.meta.error && <span style={error}>*{field.meta.error}</span>}
			</Col>
		</div>    
	)
}




// WEBPACK FOOTER //
// ./src/modules/components/fieldcomponent.js